import { IconChevronDown, IconMessageOff, IconX } from '@tabler/icons-react';
import useTranslation from 'next-translate/useTranslation';

import { Text } from '../../../Text';
import { Button, UnstyledButton } from '../../../Button';

import type { ChatHeaderProps } from './types';
import useStyles from './ChatHeader.styles';

function ChatHeader({
  title,
  subtitle,
  isCommissioner = false,
  hasUnreadMessages = false,
  onClose,
  isSidePanel = false,
  onHeaderClick,
  onToggleChatEnabled,
  ...props
}: ChatHeaderProps) {
  const { t } = useTranslation('chat');
  const { classes, theme } = useStyles({ isSidePanel });

  const displayTitle = title || t('title');

  const titleSection = (
    <div className={classes.titleGroup}>
      <div className={classes.titleWithDot}>
        <Text variant="label-medium" className={classes.title}>
          {displayTitle}
        </Text>
        {!isCommissioner && hasUnreadMessages && <div className={classes.orangeDot} />}
      </div>
      {subtitle && <div className={classes.subtitle}>{subtitle}</div>}
    </div>
  );

  return (
    <div className={classes.container} {...props}>
      <div className={classes.header}>
        <div className={classes.titleSection}>
          {!isSidePanel && !!onHeaderClick ? (
            <UnstyledButton className={classes.titleClickable} onClick={onHeaderClick}>
              {titleSection}
            </UnstyledButton>
          ) : (
            titleSection
          )}
        </div>

        <div className={classes.actions}>
          {isCommissioner && !!onToggleChatEnabled && (
            <Button
              variant="text"
              size="medium-icon"
              onClick={onToggleChatEnabled}
              aria-label={t('ariaLabels.toggleChat')}
            >
              <IconMessageOff size={24} color={theme.colors.gray2[3]} />
            </Button>
          )}
          {isSidePanel ? (
            <Button
              variant="text"
              size="medium-icon"
              onClick={onClose}
              aria-label={t('ariaLabels.closeModal')}
              className={classes.sidePanelCloseButton}
            >
              <IconX size={20} color={theme.colors.gray2[3]} />
            </Button>
          ) : (
            !!onClose && (
              <Button
                variant="text"
                size="medium-icon"
                onClick={onClose}
                aria-label={t('ariaLabels.closeModal')}
                className={classes.mobileCloseButton}
              >
                <IconChevronDown size={24} color={theme.white} />
              </Button>
            )
          )}
        </div>
      </div>
    </div>
  );
}

export default ChatHeader;
